/* eslint-disable no-unused-vars */
import {
  tokens,
} from '@fluentui/react-components';

export const actionButtonStyle = {
  color: '#323130',
  height: 24,
  display: 'inline-block',
  fontWeight: 600,
  fontSize: 12,
  lineHeight: '14px',
  padding: '4px 23px',
  marginLeft: '15px',
  background: '#FFFFFF',
  border: '1px solid #C8C6C4',
  boxSizing: 'border-box',
  borderRadius: '2px',
  position: 'relative',
  clear: 'both',
  marginTop: '6px',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: 'rgb(237, 235, 233)',
  },
};

export const topBannerContentStyle = {
  color: '#FFFFFF',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'inline-block',
  verticalAlign: 'top',
  fontSize: 12,
};

export const styles = (_theme: unknown) => ({
  topBanner: {
    background: '#A80000',
    padding: '0px 10px 0px 8px',
    lineHeight: '36px',
    height: '37px',
    borderBottom: '1px solid #e1dfdd',
    display: 'flex',
  },
  errorIcon: {
    color: '#FFFFFF',
    display: 'inline-block',
    paddingLeft: 10,
    paddingRight: 8,
    fontSize: '16px !important',
    flexShrink: 0,
    lineHeight: '36px !important',
    top: '0px !important',
  },
  addButton: {
    padding: 5,
    cursor: 'pointer',
  },
  decButton: {
    padding: 5,
    cursor: 'pointer',
  },
  invalidButton: {
    cursor: 'not-allowed !important',
    color: 'rgba(255,255,255,0.4)',
    fontSize: 12,
  },
  error: {
    color: '#FFFFFF',
    fontSize: 12,
  },
  combination: {
    display: 'inline-block',
    flexShrink: 0,
  },
  actionButton: actionButtonStyle,
  closeButton: {
    position: 'absolute',
    right: 10,
  },
});

export const stylesNew = (_theme: unknown) => ({
  topBanner: {
    display: 'flex',
    padding: `${tokens.spacingVerticalSNudge} ${tokens.spacingHorizontalM}`,
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    alignSelf: 'stretch',
    borderRadius: tokens.borderRadiusLarge,
    border: `1px solid ${tokens.colorStatusDangerBorder1}`,
    background: tokens.colorStatusDangerBackground1,
    margin: `0 ${tokens.spacingHorizontalMNudge} ${tokens.spacingVerticalS} ${tokens.spacingHorizontalMNudge}`,
    minHeight: '38px',
  },
  errorIcon: {
    flexShrink: 0,
    color: tokens.colorStatusDangerForeground1,
  },
  combination: {
    flexShrink: 0,
  },
  actionButton: {
    flexShrink: 0,
  },
  closeButton: {
    cursor: 'pointer',
    flexShrink: 0,
  },
});

export const buttonStyle = (_theme: unknown) => ({
  content: {
    color: '#FFFFFF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: 12,
  },
  calloutTargetContainer: {
    flexShrink: 0,
  },
  button: actionButtonStyle,
});

export const buttonStyleNew = (_theme: unknown) => ({
  content: {
    overflow: 'hidden',
    color: tokens.colorNeutralForeground1,
    textOverflow: 'ellipsis',
    fontSize: tokens.fontSizeBase200,
    fontWeight: tokens.fontWeightSemibold,
    flex: '1 1 auto',
    minWidth: 0,
  },
  calloutTargetContainer: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    ...actionButtonStyle,
    marginTop: tokens.spacingVerticalNone,
    color: tokens.colorNeutralForeground1,
  },
});
